export default __webpack_public_path__ + "static/media/20200618_144307.0fe07885.jpg";